// Route shell only. Implementation lives at src/dev/sample-report.impl.tsx.
// The dynamic import below uses /* @vite-ignore */ + a runtime-built string
// so Vite/Rollup's static analyzer never sees it during the production build
// and no impl chunk is emitted. In dev, Vite serves /src/dev/... directly.
// `beforeLoad` returns 404 in prod as a runtime backstop.
import { createFileRoute, notFound, lazyRouteComponent } from "@tanstack/react-router";

const DEV_IMPL_PATH = "/src/dev/" + "sample-report.impl.tsx";

export const Route = createFileRoute("/dev/sample-report")({
  beforeLoad: () => {
    if (import.meta.env.PROD) throw notFound();
  },
  component: import.meta.env.PROD
    ? () => null
    : lazyRouteComponent(() => import(/* @vite-ignore */ DEV_IMPL_PATH)),
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
});
